import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useGoalsContext } from '../GoalsContext/GoalsContext';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import { ObjectiveTimePeriodFragment } from '../../../../__generated__/graphql';
import FlairDateRange from '../../../../../../atomic/molecules/DateRange/FlairDateRange';
import { FlairDateFormat } from '../../../../../../atomic/atoms/FlairFormattedDate/types';
import './GoalPeriodSelector.css';

export const GoalPeriodSelector: React.FC = () => {
  return (
    <div className="header mb-0 mt-md-3">
      <GoalPeriodContent />
    </div>
  );
};

const GoalPeriodContent: React.FC = () => {
  const { t } = useTranslation();

  const {
    allActivePeriods,
    loading,
    currentPeriod,
    setCurrentPeriodId,
    developmentFrameworkEnabled,
  } = useGoalsContext();

  if (loading) {
    return <Skeleton height={30} width={180} />;
  }

  if (!developmentFrameworkEnabled || allActivePeriods.length === 0) {
    // backcompartibility - old logic without framework
    return (
      <div className="header-body border-0 pb-3">
        <h1 className="header-title">
          {t('performanceReview.subMenuItems.goals.title')}
        </h1>
      </div>
    );
  }

  if (allActivePeriods.length === 1) {
    return (
      <div>
        <GoalPeriodInfo period={allActivePeriods[0]} />
        <h1 className="header-title fs-2 fw-bold text-black">
          {allActivePeriods[0].Name}
        </h1>
      </div>
    );
  }

  return (
    <div>
      {currentPeriod && <GoalPeriodInfo period={currentPeriod} />}
      <Dropdown
        onSelect={(value: string | null) => setCurrentPeriodId(value)}
        className="goal-period-selector">
        <Dropdown.Toggle
          variant="link"
          className={classnames('p-0', 'fs-2', 'fw-bold', 'text-black')}>
          {currentPeriod?.Name ??
            t('performanceReview.goals2.selectGoalsPeriod')}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {allActivePeriods.map((period) => (
            <Dropdown.Item
              key={period.Id}
              eventKey={period.Id}
              active={period.Id === currentPeriod?.Id}>
              <div
                className={classnames({
                  active: period.Id === currentPeriod?.Id,
                })}>
                <div>
                  <GoalPeriodInfo period={period} />
                </div>
                <div>{period.Name}</div>
              </div>
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export const GoalPeriodInfo: React.FC<{
  period: ObjectiveTimePeriodFragment;
}> = ({ period }) => {
  return (
    <div className="text-uppercase fs-5 text-muted">
      <FlairDateRange
        format={FlairDateFormat.DayMonthLongYearFull}
        dateFrom={period.flair__Start_Date__c}
        dateTo={period.flair__End_Date__c}
      />
    </div>
  );
};
